module.exports = __webpack_public_path__ + "img/circle.61b86e19.png";